export enum AlertOPEEnum {
  GetMetricInstanceAlertStatus = 'getMetricInstanceAlertStatus',
  GetMetricInstanceAlertStatusDetail = 'getMetricInstanceAlertStatusDetail',
  PutMetricInstanceAlert = 'putMetricInstanceAlert',
  DuplicateMetricInstanceAlert = 'duplicateMetricInstanceAlert',
  DelMetricInstanceAlert = 'delMetricInstanceAlert',
  GetMetricInstanceAlertEvents = 'getMetricInstanceAlertEvents',
  GetWeekCalendar = 'getWeekCalendar',
  PutWeekCalendar = 'putWeekCalendar'
}
